module.exports = __webpack_public_path__ + "static/media/info-circle-dark.bc34e6af.svg";